import React, { useState, useEffect,useRef, useLayoutEffect } from 'react';
import {Main,Axios,Loading,uuidv4,usePaginacion,Paginacion} from '../../../Helpers/importacionesComunes'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf,faWindowClose,faFileExcel,faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import {useContextoGlobal} from '../../../Context/contextoGlobal';
import DatePicker from "react-datepicker";
import BusquedaSinForm from '../../../componentes/BusquedaSinForm';
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import es from 'date-fns/locale/es';
import "react-datepicker/dist/react-datepicker.css";
import {formatearComparacion,formatoMoneda,hacerfocoEnPrimerInput,seleccionarTextoInput} from '../../../Helpers/utilidades-globales';
import {transformarIso8601,obtenerFechaDiamenosN,obtenerFechaUltimoDiaMes} from '../../../Helpers/fechas';
import ReportesEgresosIntegrados from '../../../reportes/ReportesEgresosIntegrados';
import ImpresionPDF from '../../../componentes/ImpresionPDF';
import { Button, Card, Checkbox, Input, Option, Select, Spinner, Typography, Switch, List, ListItem, Divider } from '@material-tailwind/react';
import { convertirMesAñoAfechaCompleta } from '../../ReporteIngresosIntegrales';
import { Tabla } from '../componentes/Tabla';
import { TablaMobile } from '../componentes/TablaMobile';
import { MagnifyingGlassIcon, PlusIcon } from '@heroicons/react/24/outline';
import { useHistory, useLocation } from "react-router-dom";
import Swal from 'sweetalert2';
import { SearchResultsCounter } from '../../ComponentesComunes/SearchResultsCounter';

const EGRESOS_SEARCH_STATE_KEY = 'egresos-search-state';
const EGRESOS_DATE_FIELDS = ['mesAño', 'año', 'fechaDesde', 'fechaHasta', 'fecha'];

const normalizeText = (value) => String(value || '').trim().toLowerCase()

const parseFecha = (value) => {
    if (!value) {
        return 0
    }

    if (value instanceof Date) {
        return value.getTime()
    }

    const isoDate = new Date(value)

    if (!Number.isNaN(isoDate.getTime())) {
        return isoDate.getTime()
    }

    if (typeof value === 'string') {
        const [datePart = '', timePart = '00:00:00'] = value.split(' ')
        const [day, month, year] = datePart.split('/').map(Number)

        if (day && month && year) {
            return new Date(year, month - 1, day, ...timePart.split(':').map(Number)).getTime()
        }
    }

    return 0
}

const ordenarEgresosPorFecha = (registros = []) => {
    return [...registros].sort((a, b) => parseFecha(b.fecha) - parseFecha(a.fecha))
}

const filtrarEgresosPorTanda = (registros = [], parametros, tandas = []) => {
    if (parametros.criterio !== 'tanda') {
        return registros
    }

    const idTanda = parametros.id_tanda && parametros.id_tanda !== '*' ? Number(parametros.id_tanda) : null

    if (!idTanda) {
        return registros
    }

    const nombreTanda = normalizeText(tandas.find((item) => Number(item.id_tanda) === idTanda)?.nombre)

    // El backend ya filtra por id_tanda (se envía en dataSubmit). Las filas de /egresos/lista
    // no traen info de tanda, así que sólo aplicamos el filtro de cliente cuando los registros
    // efectivamente la traen; si no, confiamos en el backend (evita descartar todo por error).
    const traenInfoTanda = registros.some((item) =>
        Number(item?.id_tanda || item?.idTanda || 0) > 0 || normalizeText(item?.tanda_desc || item?.tanda) !== ''
    )

    if (!traenInfoTanda) {
        return registros
    }

    return registros.filter((item) => {
        const itemIdTanda = Number(item?.id_tanda || item?.idTanda || 0)
        const itemNombreTanda = normalizeText(item?.tanda_desc || item?.tanda)

        return itemIdTanda === idTanda || (nombreTanda !== '' && itemNombreTanda.includes(nombreTanda))
    })
}

const guardarEstadoBusquedaEgresos = (state) => {
    sessionStorage.setItem(EGRESOS_SEARCH_STATE_KEY, JSON.stringify(state))
}

const leerEstadoBusquedaEgresos = () => {
    const savedState = sessionStorage.getItem(EGRESOS_SEARCH_STATE_KEY)

    if (!savedState) {
        return null
    }

    try {
        const parsedState = JSON.parse(savedState)
        const parametrosRestaurados = { ...parsedState?.parametros }

        EGRESOS_DATE_FIELDS.forEach((field) => {
            if (parametrosRestaurados?.[field]) {
                parametrosRestaurados[field] = new Date(parametrosRestaurados[field])
            }
        })

        return {
            parametros: parametrosRestaurados,
            datos: Array.isArray(parsedState?.datos) ? parsedState.datos : [],
        }
    } catch (error) {
        console.log('No se pudo restaurar el estado de búsqueda de egresos', error)
        return null
    }
}

const initParams = {
    id_tanda:null,
    id_año_fiscal:10,
    mesAño:new Date(),
    año:new Date(),
    tipo:'cronologico',
    criterio:'tanda',
    destino:null,
    nombre_destino:'',
    id_obrero:null,
    id_iglesia:null,
    id_proveedor:null,                                                
    formapago:null,
    tipo_formapago: null,
    rubro:null,
    fondo:null,
    moneda:1,
    caja:null,
    fechaDesde:new Date(obtenerFechaDiamenosN(365,'MM/DD/YYYY').diamenosn),
    fechaHasta:new Date(),
    fecha:new Date(),
    descripcionCriterio:'',
    total_caja:false,
    total_diario:false,
    total_mensual:false,
    total_año:false,
    solo_efectivo : 0,
    id_tipo_compr: null,
    nro_comprobante: null,
    id_tipo_mov_banco: null,
    solo_borradores: null,
    display_tipo_mov_banco: false,
    no_agrupar:false
}

export default function Egresos(){
    const [cargandoRegistros,setCargandoRegistros] = useState(false);
    const [IsFetchingData, setIsFetchingData] = useState(false);
    const [huboError,setHuboError] = useState(false);
    const [datos,setDatos] = useState([]);
    const { esCelular } = useContextoGlobal();
    const [textoBusqueda,setTextoBusqueda] = useState('');
    const [contadorConsulta,setContadorConsulta]=useState(0);   
    const [parametros,setParametros]=useState(initParams)
    const [periodosFiscales,setPeriodosFiscales] = useState([]);
    const [tandas,setTandas] = useState([]);
    const [rubros,setRubros] = useState([]);
    const [monedas,setMonedas] = useState([]);
    const [cajas,setCajas] = useState([]);
    const [fondos,setFondos] = useState([]);
    const [formasPago,setFormasPago] = useState([]);
    const [obreros,setObreros] = useState([]);
    const [iglesias,setIglesias] = useState([]);
    const [tiposMovBanco,setTiposMovBanco] = useState([]);
    const [comprEgresos,setComprEgresos] = useState([]);
    const [reporteEnEjecucion,setReporteEnEjecucion] = useState(false)
    const meses = [0,1,2,3,4,5,6,7,8,9,10,11,12];
    const {configuracion,paginar,inicializar} = usePaginacion();
    const history = useHistory();
    const location = useLocation();
    registerLocale('es', es)


    const subtitulo = useRef('');

    useEffect(()=>{
        buscarTablasGenerales()
    },[])

    useEffect(() => {
        if (!location.state?.restoreSearch) {
            return
        }

        const estadoGuardado = leerEstadoBusquedaEgresos()

        if (estadoGuardado) {
            setParametros(estadoGuardado.parametros)
            setDatos(estadoGuardado.datos)
            setContadorConsulta(estadoGuardado.datos.length > 0 ? 1 : 0)
        }

        history.replace({
            pathname: location.pathname,
            state: undefined,
        })
    }, [history, location.pathname, location.state])

    useEffect(()=>{
        setReporteEnEjecucion(false)
        console.log(parametros);
    },[parametros])
    
    useEffect(()=>{
        if(!parametros.destino){
            setParametros({...parametros,nombre_destino:'',id_obrero:null,id_iglesia:null,id_proveedor:null})
        }else if(parametros.destino=='pastor'){
            setParametros({...parametros,nombre_destino:'',id_iglesia:null,id_proveedor:null})
            hacerfocoEnPrimerInput('destino-n')
        }else if(parametros.destino=='proveedor'){
            setParametros({...parametros,nombre_destino:'',id_iglesia:null,id_obrero:null})
            hacerfocoEnPrimerInput('destino-n')
        }else{
            setParametros({...parametros,nombre_destino:'',id_obrero:null,id_proveedor:null})
            hacerfocoEnPrimerInput('destino-n')
        }
    },[parametros.destino])

      const buscarTablasGenerales = async ()=>{
        try{
            setCargandoRegistros(true)
            const vectorResultados = await Promise.all([Axios.get('/api/tablasgenerales/reportes/tandas'),
            Axios.get('/api/tablasgenerales/reportes/perfiscales'),
            Axios.get('/api/tablasgenerales/rubrosegresos'),
            Axios.get('/api/reportes/tablas/monedas'),
            Axios.get('/api/tablasgenerales/cajas-egresos/lista'),
            Axios.get('/api/reportes/tablas/fondos'),
            Axios.get('/api/reportes/tablas/formaspago'),
            Axios.get('/api/tablasgenerales/obreros'),
            Axios.get('/api/tablasgenerales/tipo-mov-bancos/lista'),
            Axios.get('/api/tablasgenerales/tipocomprobantesegr')])
            setTandas(vectorResultados[0].data)
            setPeriodosFiscales(vectorResultados[1].data.reverse())
            setRubros(vectorResultados[2].data)
            setMonedas(vectorResultados[3].data)
            setCajas(vectorResultados[4].data)
            setFondos(vectorResultados[5].data)
            setFormasPago(vectorResultados[6].data)
            setObreros(vectorResultados[7].data)
            setTiposMovBanco(vectorResultados[8].data);
            setComprEgresos(vectorResultados[9].data);

            setCargandoRegistros(false)
        }catch(err){
            setCargandoRegistros(false)
            setHuboError(true)
            console.log('Error al buscar los datos generales')  
        }
    }

    const finalizarReporte = ()=>{
        setReporteEnEjecucion(false)
    }

    const buscarIglesiasPorObrero = async (e)=>{
        const id_obrero = e.target.value;
        setParametros({...parametros, id_obrero, id_iglesia: null});
        try{
            if (!id_obrero) {
                setIglesias([]);
                return;
            }
            const iglesias = await Axios.get('/api/tablasgenerales/iglesiasobrero/'+id_obrero)
            setIglesias(iglesias.data)
        }catch(err){
            console.log('Error al buscar los datos generales')  
        }
    }

    const crearSubtitulosSegunParametros = ()=>{
        let descripcion = '';

        switch(parametros.criterio){
            case 'tanda':
                descripcion = `${descripcion} Tanda: ${tandas.filter(item=>item.id_tanda==parametros.id_tanda).map(item=>item.nombre)}`; break
            case 'añofiscal':
                descripcion = `${descripcion} Año fiscal: ${periodosFiscales.filter(item=>item.id_año_fiscal==parametros.id_año_fiscal).map(item=>item.nombre)}`; break
            case 'mesaño':
//                descripcion = `${descripcion} ${document.getElementById('select-mesaño').options[document.getElementById('select-mesaño').selectedIndex].text}`; break
                descripcion = `${descripcion} Mes y año: ${document.getElementById('select-mesaño').value}`; break
            case 'año':
                descripcion = `${descripcion} Año: ${document.getElementById('select-año').value}`; break
            case 'periodo':
                descripcion = `${descripcion} Período: ${document.getElementById('select-periodo-fdesde').value} -->  ${document.getElementById('select-periodo-fhasta').value}`; break
            case 'fecha':
                descripcion = `${descripcion} Fecha: ${document.getElementById('select-fecha').value}`; break
        }

        if (parametros.tipo=='cronologico'){
            //dos formas de recuperar el texto de un select, usando el vector y filter o usando el id y accediendo al DOM
            descripcion = `${descripcion} Moneda: ${monedas.filter(item=>item.id_tipo_moneda==parametros.moneda).map(item=>item.nombre)}`; 
//            descripcion = `${descripcion} Moneda: ${document.getElementById('select-moneda').options[document.getElementById('select-moneda').selectedIndex].text}`
        
            if (parametros.destino){
                descripcion = `${descripcion} Proveedor: ${parametros.destino=='pastor' ? 'Pr. ' : parametros.destino=='iglesia' ? 'Igl.' : ' '} ${parametros.nombre_destino}`
            }

            if (parametros.caja){
                descripcion = `${descripcion} Caja: ${document.getElementById('select-caja').options[document.getElementById('select-caja').selectedIndex].text}`
            }

            if (parametros.fondo){
                descripcion = `${descripcion} Fondo: ${document.getElementById('select-fondo').options[document.getElementById('select-fondo').selectedIndex].text}`
            }

            if (parametros.rubro){
                descripcion = `${descripcion} Rubro: ${document.getElementById('select-rubro').options[document.getElementById('select-rubro').selectedIndex].text}`
            }

            if (parametros.formapago){
                descripcion = `${descripcion} Forma de pago: ${document.getElementById('select-fpago').options[document.getElementById('select-fpago').selectedIndex].text}`
            }

        }
        return descripcion
    }

    const ejecutarBusqueda = async () => { 
        setIsFetchingData(true);
        try {
            let dataSubmit = {
                fecha_desde: parametros.criterio === 'periodo' ? convertirMesAñoAfechaDesde(parametros.fechaDesde) : parametros.criterio === 'fecha' ? convertirMesAñoAfechaCompleta(parametros.fecha) :  null,
                fecha_hasta: parametros.criterio === 'periodo' ? convertirMesAñoAfechaHasta(parametros.fechaHasta) : parametros.criterio === 'fecha' ? convertirMesAñoAfechaCompleta(parametros.fecha) : null,
                id_tanda: parametros.criterio === 'tanda' && parametros.id_tanda && parametros.id_tanda !== '*' ? Number(parametros.id_tanda) : null,
                id_obrero: parametros.id_obrero ? Number(parametros.id_obrero) : null,
                id_iglesia: parametros.id_iglesia ? Number(parametros.id_iglesia) : null,
                id_proveedor: parametros.id_proveedor ? Number(parametros.id_proveedor) : null,
                solo_borradores: parametros.solo_borradores,
                id_tipo_compr: parametros.id_tipo_compr,
                nro_comprobante: parametros.nro_comprobante,
                solo_efectivo: parametros.solo_efectivo,
                id_tipo_mov_banco: parametros.id_tipo_mov_banco,
                id_rubro: parametros.rubro ? Number(parametros.rubro) : null,
                id_caja: parametros.id_caja ? Number(parametros.id_caja) : null,
            };

            const dataBusqueda = await Axios.post('/api/tablasgenerales/egresos/lista', dataSubmit);
            const datosFiltrados = ordenarEgresosPorFecha(
                filtrarEgresosPorTanda(dataBusqueda.data, parametros, tandas)
            )

            console.log("dataBusqueda.data", dataBusqueda.data);
            if (datosFiltrados.length === 0) Swal.fire(`No se ha encontrado ningún registro`,'','info')
            setDatos(datosFiltrados); 
            guardarEstadoBusquedaEgresos({
                parametros,
                datos: datosFiltrados,
            })
            setIsFetchingData(false);             
        } catch (error) {
            console.log('Error al ejecutar la búsqueda', error);
            setIsFetchingData(false);
        }
    }

    const cleanUpData = () => { 
        setDatos([]);
    }

    const cb_filtro = item=>
    formatearComparacion(item.codigo_rubro).includes(formatearComparacion(textoBusqueda)) ||
    formatearComparacion(item.rubro).includes(formatearComparacion(textoBusqueda))


    if (huboError){
        return <Main center>
            <div className='flex flex-col justify-center items-center h-[calc(100vh-10rem)]'>
                <p>Se produjo un error al cargar los datos para esta vista</p>
            </div>
        </Main>
    }

    if (cargandoRegistros){
        return <Main center alinear>
                    <div className='flex flex-col justify-center items-center h-[calc(100vh-10rem)]'>
                        <Spinner className="h-12 w-12" />
                        <span className="cargando font-semibold text-[15px]">Cargando registros...</span>
                    </div>
                </Main>
    };

    return (  
    <Main center>  
        <div className={'w-full px-6'}>
            <div className="flex f-col text-large justify-center items-center mb-4">
                <Typography variant="h4">
                    Egresos
                </Typography>
            </div>

            <Parametros parametros = {parametros} 
                        setParametros={setParametros} 
                        tandas={tandas} 
                        periodosFiscales ={periodosFiscales} 
                        buscarIglesiasPorObrero ={buscarIglesiasPorObrero}
                        centrado={contadorConsulta==0 ? true : false}
                        cajas = {cajas}
                        rubros = {rubros}
                        monedas = {monedas}
                        fondos = {fondos}
                        formasPago = {formasPago}
                        obreros = {obreros}
                        tiposMovBanco = {tiposMovBanco}
                        comprEgresos = {comprEgresos}
                        IsFetchingData = {IsFetchingData}
                        ejecutarBusqueda = {ejecutarBusqueda}/>
                </div>

        {datos.length > 0 && <SearchResultsCounter count={datos.length} badgeLabel="Egresos" />}

        {esCelular && datos.length > 0 && <TablaMobile registrosAmostrar={datos} cleanUpData={cleanUpData} />}

        {!esCelular && datos.length > 0 && <Tabla
            registrosAmostrar={datos}
            cleanUpData={cleanUpData}
        />}
    </Main>
    )
}

function Parametros({parametros,
                    setParametros,
                    cajas,
                    tandas,
                    buscarIglesiasPorObrero,
                    periodosFiscales,
                    centrado,
                    rubros,
                    tiposMovBanco,
                    comprEgresos,
                    monedas,
                    fondos,
                    obreros,
                    IsFetchingData,
                    ejecutarBusqueda,
                    setNombreCriterio}){
    
    const history = useHistory();
    const inputBusquedaRef = useRef()
    const nombreCriterio = useRef('Seleccione la tanda:')
    const r2 = useRef('null')

    const [buscarDestino,setBuscarDestino] = useState(false)
    const { esCelular} = useContextoGlobal();

    const handleCheckCriterio = (e)=>{
        const nuevoCriterio = e.target.value
        reinicializarCriterios(setParametros,parametros,nuevoCriterio,tandas,periodosFiscales,setNombreCriterio)
        cargarNombreCriterio(nuevoCriterio,nombreCriterio)
        hacerfocoEnPrimerInput(`select-${e.target.value}`)
    }

    const handleCheckTipo = (e)=>{
        setParametros({...parametros,tipo : e.target.value,criterio:'tanda'})
    }

    const handleCheckSoloBorradores = (e)=>{
        console.log(e.target.value);
        setParametros({...parametros, solo_borradores : e.target.value === 'on' ? 1 : 0})
    }

    const handleChangeNombre = (e)=>{
        setParametros({...parametros,nombre_destino : e.target.value})
    }

    const finalizarSeleccionObrero = (item)=>{
        setParametros({...parametros,id_obrero : item.id_obrero,nombre_destino:item.nom_simple,id_proveedor:null,id_iglesia:null})
        setBuscarDestino(false)
    }

    const finalizarSeleccionProveedor = (item)=>{
        setParametros({...parametros,id_proveedor : item.id_proveedor,nombre_destino:item.nombre,id_obrero:null,id_iglesia:null})
        setBuscarDestino(false)
    }

    const finalizarSeleccionIglesia = (item)=>{
        setParametros({...parametros,id_iglesia : item.id_iglesia,nombre_destino:item.nombre,id_proveedor:null,id_obrero:null})
        setBuscarDestino(false)
    }

    const validarParametros = ()=>{
        if (parametros.destino=="proveedor" && !parametros.id_proveedor){
            alert('Falta seleccionar un proveedor')
            inputBusquedaRef.current.focus()
            return
        }
        if (parametros.destino=="pastor" && !parametros.id_obrero){
            alert('Falta seleccionar un ministro')
            inputBusquedaRef.current.focus()
            return
        }
        if (parametros.destino=="iglesia" && !parametros.id_iglesia){
            alert('Falta seleccionar una iglesia')
            inputBusquedaRef.current.focus()
            return
        }

        if (parametros.criterio=="periodo" && (!parametros.fechaHasta || !parametros.fechaDesde)){
            alert('Falta seleccionar un mes y un año')
            return
        }
        ejecutarBusqueda()
    }

   const onChangeFormaPago = (e)=> { 
    const formap = e.target.value;

    if (!formap) setParametros({ ...parametros, display_tipo_mov_banco: false, solo_efectivo: 0, id_tipo_mov_banco: null });
    if (formap === 'cash') setParametros({ ...parametros, display_tipo_mov_banco: false, solo_efectivo: 1, id_tipo_mov_banco: null });
    if (formap === 'accmovement') setParametros({ ...parametros, solo_efectivo: 0, display_tipo_mov_banco: true, id_tipo_mov_banco: null });
   }

   const limpiarFiltros = () => { 
    setParametros(initParams);
   }
    
    return <>
        <Card className="mt-4 w-full p-10 mb-0 relative">
                <div className="flex f-col mt-4">
                    {/*<Prueba ref2={r2}/>
                    <button onClick ={()=>alert(r2.current.options[r2.current.selectedIndex].text)}>macho</button>*/}
                    
                   <Card className="w-full px-6 py-3 mb-3 shadow-md">
                       <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
                           {/* Primera columna */}
                           <div className="flex items-center gap-2 w-full egreso-new">
                               <div className='w-[220px]'>
                                   <Typography variant="h6" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                       Intervalo de Tiempo:
                                   </Typography>
                               </div>
                               <div className="w-full">
                                   <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-full">
                                        <select
                                            label="Seleccionar Intervalo"
                                            value={parametros.criterio}
                                            className='select-bg-ui w-full'
                                            onChange={(val) =>  handleCheckCriterio(val)}
                                        >
                                            <option value="tanda">Tanda</option>
                                            <option value="periodo">Periodo</option>
                                            <option value="fecha">Fecha</option>
                                        </select>                                        
                                   </div>   
                               </div>
                           </div>

                            <div className="flex flex-col w-full">
                                <div className="relative mt-2 w-full">
                                {parametros.criterio=="tanda" && <div className="flex f-row w-full">
                                        <Seleccionador id="select-tanda" vector={tandas} valor={parametros.id_tanda} nombre="Todas" onchange={(e)=>setParametros({...parametros,id_tanda:e.target.value})} claves={{id:'id_tanda',nombre:'nombre'}}/>
                                    </div>}   

                                    {parametros.criterio=="mesaño" && <div className="flex f-row w-full">
                                                {<DatePicker selected={parametros.mesAño} 
                                                    onChange={date => setParametros({...parametros,mesAño:date})} 
                                                    locale="es"
                                                    dateFormat="MM/yyyy"
                                                    id="select-mesaño"
                                                    className="select-bg-ui !h-9"
                                                    showMonthYearPicker
                                                    showFullMonthYearPicker
                                                    showFourColumnMonthYearPicker
                                                />}
                                    </div>}

                                    {parametros.criterio=="año" && <div className="flex f-row w-full">
                                                {<DatePicker selected={parametros.año} 
                                                    onChange={date => setParametros({...parametros,año:date})} 
                                                    locale="es"
                                                    id="select-año"
                                                    className="select-bg-ui !h-9"
                                                    showYearPicker
                                                    dateFormat="yyyy"
                                                />}
                                    </div>}

                                    {parametros.criterio=="periodo" && <div className="flex f-row w-full">
                                            <div className="flex f-row w-full">
                                                        <div className="flex f-col mt-[-15px]">
                                                            <span className="text-xsmall">Desde</span>
                                                            <DatePicker selected={parametros.fechaDesde} 
                                                                onChange={date => setParametros({...parametros,fechaDesde:date})} 
                                                                locale="es"
                                                                dateFormat="MM/yyyy"
                                                                id="select-periodo-fdesde"
                                                                showMonthYearPicker
                                                                className="select-bg-ui !h-9"
                                                                showFullMonthYearPicker
                                                                showFourColumnMonthYearPicker/>
                                                        </div>
                                                        <div className="flex f-col ml-2 w-full mt-[-15px]">
                                                            <span className="text-xsmall">Hasta</span>
                                                            <DatePicker selected={parametros.fechaHasta} 
                                                                onChange={date => setParametros({...parametros,fechaHasta:date})} 
                                                                locale="es"
                                                                dateFormat="MM/yyyy"
                                                                id="select-periodo-fhasta"
                                                                className="select-bg-ui !h-9"
                                                                showMonthYearPicker
                                                                showFullMonthYearPicker
                                                                showFourColumnMonthYearPicker/>
                                                        </div>
                                            </div>
                                    </div>}

                                    {parametros.criterio=="fecha" && <div className="flex f-row w-full">
                                            <div className="flex f-row w-full egreso-list">
                                                    <DatePicker selected={parametros.fecha} 
                                                        id="select-fecha"
                                                        className="select-bg-ui !h-9 w-full"
                                                        onChange={date => setParametros({...parametros,fecha:date})} 
                                                        locale="es"/>
                                            </div>
                                    </div>}
                                </div>
                            </div>

                            {/* Segunda columna */}
                            <div className="flex items-center gap-2 egreso-new">
                                <div className="w-[220px]">
                                    <Typography variant="h6" color="blue-gray" className="mt-1">
                                        Pagado a:
                                    </Typography>
                                </div>
                                <div className="select-ui-data mt-3 w-full">
                                    <Select
                                        label="Seleccionar Destino"
                                        value={parametros.destino ?? ''}
                                        className='select-bg-ui w-[95%]'
                                        onChange={(val) => setParametros({...parametros, destino: val === '' ? null : val})}
                                    >
                                        <Option value={''}>Todos</Option>
                                        <Option value="proveedor">Proveedor</Option>
                                        <Option value="iglesia">Iglesia</Option>
                                        <Option value="pastor">Pastor</Option>
                                    </Select>
                                </div>
                            </div>

                            <div className="flex flex-col">
                                <div className="relative col-span-2 ... mt-3">
                                    <Input
                                        name="asunto"
                                        onInput={()=>setBuscarDestino(true)} 
                                        id="destino-n" onClick={()=>seleccionarTextoInput("destino-n")} 
                                        type="text" value={parametros.nombre_destino} 
                                        onChange={handleChangeNombre} ref={inputBusquedaRef} 
                                        placeholder={parametros.destino == 'pastor' ? 'Buscar un ministro' : parametros.destino=='proveedor' ? 'Buscar un proveedor' : 'Buscar una iglesia'}
                                        className="input-ui-data w-full"
                                        labelProps={{
                                            className: "before:content-none after:content-none",
                                        }}
                                    />
                                    { parametros.id_pastor && 
                                        <button>
                                            <FontAwesomeIcon className="ic-abm"
                                                            icon={faWindowClose} 
                                                            onClick={()=>console.log('pastor')}/>
                                        </button>}  
                                        {buscarDestino && parametros.destino=='pastor' && parametros.nombre_destino.length > 2 && 
                                            <div className="w-fll lg:w-96 bg-gray-300 absolute z-50">
                                                <BusquedaSinForm texto={parametros.nombre_destino} finalizarSeleccion={finalizarSeleccionObrero} origen="obreros"/>
                                            </div>
                                        }
                                        {buscarDestino && parametros.destino=='proveedor' && parametros.nombre_destino.length > 2 && 
                                            <div className="w-fll lg:w-96 bg-gray-300 absolute z-50">
                                                <BusquedaSinForm texto={parametros.nombre_destino} finalizarSeleccion={finalizarSeleccionProveedor} origen="proveedores"/>
                                            </div>
                                        }
                                        {buscarDestino && parametros.destino=='iglesia' && parametros.nombre_destino.length > 2 && 
                                            <div className="w-fll lg:w-96 bg-gray-300 absolute z-50">
                                                <BusquedaSinForm texto={parametros.nombre_destino} finalizarSeleccion={finalizarSeleccionIglesia} origen="iglesias"/>
                                            </div>
                                        }
                                </div>
                            </div>
                        </div>
                            

                        <div className="flex items-center gap-2 w-full">
                            <div className="w-[220px]">
                                <Typography variant="h6" color="blue-gray" className="mt-1 mb-1 lg:mb-0 lg:mt-4">
                                    Egreso borrador:
                                </Typography>
                            </div>
                            <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-4 w-full">
                                <Switch
                                    ripple={false}
                                    name="checkcaja"
                                    checked={parametros.solo_borradores === 1}
                                    onChange={(e) => setParametros({ ...parametros, solo_borradores: e.target.checked ? 1 : 0 })}
                                />
                            </div> 
                        </div>
                   </Card>

                    <Card className="w-full px-6 py-3 mb-3 shadow-md">
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-1">
                            {/* Primera columna */}
                            <div className="flex items-center gap-2 w-full egreso-new">
                                <div className="w-[220px]">
                                    <Typography variant="h6" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                        Fondo:
                                    </Typography>
                                </div>
                                <div className="w-full">
                                    <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                        <Seleccionador id='select-rubro' vector={rubros} valor={parametros.rubro} nombre="Todos" onchange={(e)=>setParametros({...parametros,rubro:e.target.value})} claves={{id:'id_rubro_egreso',nombre:'nombre'}}/>
                                    </div>   
                                </div>
                            </div>

                            <div className="flex items-center gap-2 w-full">
                                <div className="w-[220px]">
                                    <Typography variant="h6" color="blue-gray" className="mt-1">
                                        Caja:
                                    </Typography>
                                </div>
                                <div className="w-full">
                                    <div className="ml-2 mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                        <Seleccionador id='select-caja' vector={cajas} valor={parametros.caja} nombre="Todos" onchange={(e)=>setParametros({...parametros,caja:e.target.value})} claves={{id:'id_caja',nombre:'nombre'}}/>
                                    </div>
                                </div>
                            </div>

                            
                            {/* Segunda columna */}
                            <div className="flex items-center gap-2 w-full">
                                <div className="w-[220px]">
                                    <Typography variant="h6" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                        Egreso Específico:
                                    </Typography>
                                </div>
                                <div className="w-full">
                                    <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                        <Seleccionador id='select-caja' vector={comprEgresos} valor={parametros.id_tipo_compr} nombre="Todos" onchange={(e)=>setParametros({...parametros,id_tipo_compr:e.target.value})} claves={{id:'id_tipo_compr',nombre:'nombre'}}/>
                                    </div>   
                                </div>
                            </div>

                            <div className="flex items-center gap-2 w-full">
                               <div className="w-[220px]">
                                   <Typography variant="h6" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                        N° Comprobante:
                                   </Typography>
                               </div>
                               <div className="w-full">
                                   <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                        <Input
                                            onChange={(e) => setParametros({ ...parametros, nro_comprobante: e.target.value })} 
                                            name="nombre" 
                                            color='black'
                                            placeholder="N° Comprobante" 
                                            maxLength={200}
                                            className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                                            labelProps={{
                                                className: "before:content-none after:content-none",
                                            }}
                                        />
                                   </div>   
                               </div>
                           </div>
                            
                            {/* Tercera columna */}
                            <div className="flex items-center gap-2 w-full">
                                <div className="w-[220px]">
                                    <Typography variant="h6" color="blue-gray" className="mt-1">
                                        Forma de Pago:
                                    </Typography>
                                </div>
                                <div className="w-full">
                                    <div className="ml-2 mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                        <select value={parametros.tipo_formapago} 
                                            className='h-9 w-full' 
                                            onChange={onChangeFormaPago} 
                                        >
                                            <option value={null}>Todos</option>
                                            <option value={"cash"}>
                                                Efectivo
                                            </option> 
                                            <option value={"accmovement"}>
                                                Movimiento Bancario
                                            </option> 
                                        </select>
                                    </div>
                                </div>  
                            </div>
                                        
                            <div className="flex items-center gap-2 w-full">
                                <div className="w-[220px]">
                                    <Typography variant="h6" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                        Movimiento Bancario:
                                    </Typography>
                                </div>
                                <div className="w-full">
                                    <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                        <Seleccionador vector={tiposMovBanco} valor={parametros.id_tipo_mov_banco} nombre="Todos" onchange={(e)=>setParametros({...parametros,id_tipo_mov_banco:e.target.value})} claves={{id:'id_tipo_mov_banco',nombre:'nombre'}}/>
                                    </div>   
                                </div>
                            </div>

                        </div>
                    </Card>

                    <div className='mt-4 flex w-full justify-center pr-4 md:justify-end'>
                        <div className='flex'>
                            <Button 
                                className="h-[40px] w-40 flex items-center justify-center gap-2 bg-[#2FB18F] text-white" 
                                onClick={() => { 
                                    history.push('/egresos/crear') 
                                }}>
                                <PlusIcon className="h-4 w-4" />
                                Añadir
                            </Button>
                        </div>
                    </div>
            </div>
        </Card>
        <div className='mt-3 flex w-full flex-wrap justify-end gap-2 pr-4'>
            <Button
                    color="blue"
                    className="flex justify-center rounded-md h-[40px] w-40"
                    onClick={validarParametros}
                >
                    {IsFetchingData ? 
                        <Spinner className="h-4 w-4 mr-2" /> : 
                        <>
                            <MagnifyingGlassIcon className="h-4 w-4 mr-2" /> Buscar
                        </>
                    }  
            </Button>
            <Button 
                variant='text' 
                className='text-red-400 bg-red-100 hover:bg-red-200 h-[40px] w-40' 
                onClick={limpiarFiltros}>
                    Limpiar Filtros
            </Button>
        </div>
    </>
}

function Seleccionador({
    valor, 
    name, 
    onchange, 
    id, 
    noDefault, 
    nombre, 
    vector, 
    claves, 
    limpiar,
    classancho
  }){
    let clasesSelect = "block appearance-none w-100 select-titulo rounded shadow leading-tight";
    let clasesActivo = "block appearance-none w-full select-titulo rounded shadow leading-tight";

    if (classancho){
        clasesSelect=`block appearance-none ${classancho} select-titulo rounded shadow leading-tight`
    }

    //recordar que un objeto puedo leerlo de 2 formas como vector o como objeto
    // es lo mismo usuario['nombre'] que usuario.nombre
    // aprovecho esta característica para hacer un seleccionador genérico y le paso
    // el nombre de la clave y el texto como un string para referenciarlo en notación vector
    return (            
        <div className="flex flex-col sel select-ui-data w-full">
            <select value={valor} name={name? name : ''} className='h-9' onChange ={onchange} id={id? id : null}>
                { noDefault ? null : <option value="*" key="1">{nombre}</option>}
                {vector.map(item=>
                        <option value={item[claves.id]} key={item[claves.id]}>
                            {item[claves.nombre]}
                        </option> 
                    )}
            </select>
            { valor!="*" && limpiar && 
                        <button>
                            <FontAwesomeIcon className="ic-abm"
                                            icon={faWindowClose} 
                                            onClick={limpiar}/>
                        </button>}  
        </div>
        )
        
}   

function determinarClases(reporteEnEjecucion){
    return reporteEnEjecucion ? "items-center justify-center ml-auto mr-auto" : "flex f-col items-center justify-center ml-auto mr-auto"
}

function objetosSegunParametros(parametros,objeto){

    if (parametros.tipo=='cronologico'){
        switch(objeto){
            case 'api': return `api/reportes/reporteegresos/${masParametros(parametros)}`
            case 'titulo': return 'Egresos cronológicos'
            case 'titulos': return {col1:'Fecha',col2:'Proveedor',col3:'Comprobante',col4:'Descripcion',col5:'Monto'}
            case 'columnas' : return {col1:'Manejo las columnas en la funcion bodyTablaEgresosCronologicos'}
            case 'filtro' : return {campo1:'proveedor',campo2:'descripcion', campo3:'rubro', campo4:'caja',campo5:'fondo',campo6:'datos_bcrios',campo7:'monto_numerico'}
            case 'csv' : return item=>{return {fecha:transformarIso8601(item.fecha),proveedor:item.proveedor,tipo_comp:item.tipo_compr,nro_comprobante:item.nro_compr,descripcion:item.descripcion,monto:item.monto,caja:item.caja,rubro:item.rubro,fondo:item.fondo,datos_bancarios:item.datos_bcrios,tanda:item.tanda_desc}}
            case 'pdf' : return item => { return { 
                fecha: transformarIso8601(item.fecha), 
                proveedor: item.proveedor, 
                comprobante: `${item.tipo_compr}/${item.nro_compr}`, 
                descripcion: item.descripcion, 
                monto: item.monto, 
                caja: item.caja, 
                rubro: item.rubro,
                fondo:item.fondo,
                tanda:item.tanda_desc,
                datos_bancarios: item.datos_bcrios}
            }
            case 'excel' : return [{label:'Proveedor',value:'proveedor'},
                        {label:'Rubro',value:'rubro'},
                        {label:'Caja',value:'caja'},
                        {label:'Descripción',value:'descripcion'},
                        {label:'Datos bancarios',value:'datos_bcrios'},
                        {label:'Fondo',value:'fondo'},
                        {label:'TC',value:'tipo_compr'},
                        {label:'Comprobante',value:'nro_compr'},
                        {label:'Monto',value:'monto'},{label:'Monto plano',value:'monto_numerico'}]
            case 'arraypdf' : return [{ text: 'Fecha', style: 'tableHeader' }, 
            { text: 'Proveedor', style: 'tableHeader' }, 
            { text: 'Comprobante', style: 'tableHeader' }, 
            { text: 'Descripción', style: 'tableHeader' }, 
            { text: 'Monto', style: 'tableHeader' }, 
            { text: 'Caja', style: 'tableHeader' }, 
            { text: 'Rubro', style: 'tableHeader' },
            { text: 'Fondo', style: 'tableHeader' },
            { text: 'Tanda', style: 'tableHeader' },
            { text: 'Info Banco', style: 'tableHeader' }]
            case 'orientacion' : return 'landscape'
            case 'subtitulo' : return 'landscape'
            case 'clasesbody' : return {col1:'filas-lista-ec ti-reporte-xl',col2:'filas-lista-ec ti-reporte-xxl',col3:'filas-lista-ec ti-reporte-xl',col4:'filas-lista-ec ti-reporte-xxl',col5:'filas-lista-ec ti-reporte-xl text-right'}
            case 'claseshead' : return {col1:'filas-lista-em ti-reporte-xl',col2:'filas-lista-em ti-reporte-xxl',col3:'filas-lista-em ti-reporte-xl',col4:'filas-lista-em ti-reporte-xxl text-center',col5:'filas-lista-em ti-reporte-xl text-right'}
        }
    }else{
        switch(objeto){
            case 'api': return `api/reportes/resumenegresos/${masParametros(parametros)}`
            case 'titulo': return 'Resumen de egresos'
            case 'titulos': return {col1:'Rubro',col2:'Código',col3:'Mes',col4:'Año',col5:'Monto'}
            case 'columnas' : return {col1:'rubro',col2:'codigo_rubro',col3:'mes_largo',col4:'año',col5:'egreso'}
            case 'filtro' : return {campo1:'rubro',campo2:'codigo_rubro',campo3:'egreso_numerico'}
            case 'csv' : return item=>{return {rubro:item.rubro,codigo_rubro:item.codigo_rubro,egreso:item.egreso,periodo:`${item.mes_largo} ${item.año}`}}
            case 'pdf' : return item => { return { 
                rubro: item.rubro, 
                codigo_rubro: item.codigo_rubro, 
                año: item.año,
                mes:item.mes,
                periodo: `${item.mes_largo} ${item.año}`, 
                egreso: item.egreso}
            }
            case 'excel' : return [{label:'Rubro',value:'rubro'},{label:'Código',value:'codigo_rubro'},{label:'Egreso',value:'egreso'},{label:'Mes',value:'mes_largo'},{label:'Año',value:'año'}]
            case 'arraypdf' : return [{ text: 'Rubro', style: 'tableHeader' }, 
            { text: 'Cod. Rubro', style: 'tableHeader' }, 
            { text: 'Período', style: 'tableHeader' }, 
            { text: 'Egreso', style: 'tableHeader' }]
            case 'orientacion' : return 'portrait'
            case 'clasesbody' : return {col1:'',col2:'',col3:'',col4:'',col5:'text-right'}
            case 'claseshead' : return {col1:'',col2:'',col3:'',col4:'',col5:'text-right'}
        }
    }
}


function bodyTablaEgresosCronologicos (clasesbody){
    return item => {
        return (
                <tr  className="border-bottom-solid" key={uuidv4()}>
                    <td>
                                {transformarIso8601(item.fecha)} {/*Recordar que puedo referenciar a un objeto como objeto.campo o objeto['nombre_campo']*/}
                                <p title='Caja' className='text-small text-white bg-tomato'>{item.caja}</p>
                                <p title='Rubro' className='text-small'>{item.rubro}</p>
                                <p title='Fondo' className='text-small text-grey-dark'>{item.fondo}</p>
                    </td>
                    <td>
                        {item.proveedor} {/*Recordar que puedo referenciar a un objeto como objeto.campo o objeto['nombre_campo']*/}
                    </td>
                    <td>
                        {item.tipo_compr}-{item.nro_compr} {/*Recordar que puedo referenciar a un objeto como objeto.campo o objeto['nombre_campo']*/}
                    </td>
                    <td>
                         {item.descripcion} {/*Recordar que puedo referenciar a un objeto como objeto.campo o objeto['nombre_campo']*/}
                    </td>
                    <td className='text-right'>
                         {item.monto} {/*Recordar que puedo referenciar a un objeto como objeto.campo o objeto['nombre_campo']*/}
                    </td>                    
                </tr>
            )
        }
}

function masParametros(parametros){

    if (parametros.tipo=='cronologico'){
        switch(parametros.criterio){
            case 'tanda': return `*/*/*/*/${parametros.id_tanda}/*/*/${noNull(parametros.id_proveedor)}/${noNull(parametros.id_iglesia)}/${noNull(parametros.id_obrero)}/${noNull(parametros.moneda)}/${noNull(parametros.formapago)}/${noNull(parametros.fondo)}/${noNull(parametros.rubro)}/${noNull(parametros.caja)}`
            case 'añofiscal': return `*/*/*/${parametros.id_año_fiscal}/*/*/*/${noNull(parametros.id_proveedor)}/${noNull(parametros.id_iglesia)}/${noNull(parametros.id_obrero)}/${noNull(parametros.moneda)}/${noNull(parametros.formapago)}/${noNull(parametros.fondo)}/${noNull(parametros.rubro)}/${noNull(parametros.caja)}`
            case 'año': return `*/*/${parametros.año.getFullYear()}/*/*/*/*/${noNull(parametros.id_proveedor)}/${noNull(parametros.id_iglesia)}/${noNull(parametros.id_obrero)}/${noNull(parametros.moneda)}/${noNull(parametros.formapago)}/${noNull(parametros.fondo)}/${noNull(parametros.rubro)}/${noNull(parametros.caja)}`
            case 'mesaño': return `*/${parametros.mesAño.getMonth()+1}/${parametros.mesAño.getFullYear()}/*/*/*/*/${noNull(parametros.id_proveedor)}/${noNull(parametros.id_iglesia)}/${noNull(parametros.id_obrero)}/${noNull(parametros.moneda)}/${noNull(parametros.formapago)}/${noNull(parametros.fondo)}/${noNull(parametros.rubro)}/${noNull(parametros.caja)}`
            case 'periodo': return `*/*/*/*/*/${convertirMesAñoAfechaDesde(parametros.fechaDesde)}/${convertirMesAñoAfechaHasta(parametros.fechaHasta)}/${noNull(parametros.id_proveedor)}/${noNull(parametros.id_iglesia)}/${noNull(parametros.id_obrero)}/${noNull(parametros.moneda)}/${noNull(parametros.formapago)}/${noNull(parametros.fondo)}/${noNull(parametros.rubro)}/${noNull(parametros.caja)}`
            case 'fecha': return `${parametros.mesAño.getDate()}/${parametros.mesAño.getMonth()+1}/${parametros.mesAño.getFullYear()}/*/*/*/*/${noNull(parametros.id_proveedor)}/${noNull(parametros.id_iglesia)}/${noNull(parametros.id_obrero)}/${noNull(parametros.moneda)}/${noNull(parametros.formapago)}/${noNull(parametros.fondo)}/${noNull(parametros.rubro)}/${noNull(parametros.caja)}`
        }
    }else{
        switch(parametros.criterio){
            case 'tanda': return `*/*/*/${parametros.id_tanda}`
            case 'añofiscal': return `*/*/${parametros.id_año_fiscal}/*`
            case 'año': return `*/${parametros.año.getFullYear()}/*/*`
            case 'mesaño': return `${parametros.mesAño.getMonth()+1}/${parametros.mesAño.getFullYear()}/*/*`
        }
    }
}

function noNull(valor){
    if (valor){
        return valor
    }else{
        return '*'
    }
}

function convertirMesAñoAfechaDesde(fecha){
    
    // el propósito de esta conversión es recibir una fecha que fue tomada del datepicker en formato
    // mes/año y asegurar que la fecha desde es el primer día del mes y año seleccionados
    // también asegurarnos que se envía separado por guiones para que la fecha pueda viajar
    // sin errores en el request (no puedo mandar barras invertidas por ejemplo)

    const fecha_new = new Date(fecha)

    const mes = fecha_new.getMonth() + 1

   // const dia = fecha_new.getDate()

    const anio = fecha_new.getFullYear()
    

  // return `${mes < 10 ? `0${mes}` : mes}-01-${anio}`
   return `${anio}-${mes < 10 ? `0${mes}` : mes}-01`

}

function convertirMesAñoAfechaHasta(fecha){
        
    // el propósito de esta conversión es recibir una fecha que fue tomada del datepicker en formato
    // mes/año y asegurar que la fecha hasta es el último día del mes y año seleccionados
    // también asegurarnos que se envía separado por guiones para que la fecha pueda viajar
    // sin errores en el request (no puedo mandar barras invertidas por ejemplo)

    const fecha_new = new Date(fecha)

    const mes = fecha_new.getMonth() + 1

    const dia = fecha_new.getDate()

    const anio = fecha_new.getFullYear()
    
   const nueva_fecha =  `${anio}-${mes < 10 ? `0${mes}` : mes}-${dia < 10 ? `0${dia}` : dia}`

    return obtenerFechaUltimoDiaMes(nueva_fecha,'YYYY-MM-DD','YYYY-MM-DD')
}

const reinicializarCriterios = (setParametros,parametros,nuevoCriterio,tandas,periodosFiscales)=>{


    setParametros({...parametros,
                      criterio : nuevoCriterio,
                      id_tanda:tandas[0].id_tanda,
                      id_año_fiscal:periodosFiscales[0].id_año_fiscal,
                      fechaDesde:new Date(obtenerFechaDiamenosN(365,'MM/DD/YYYY').diamenosn),
                      fechaHasta:new Date(),
                      fecha:new Date(),
                      mesAño:new Date(),
                      año:new Date(),
                    })
}

const cargarNombreCriterio = (nuevoCriterio,nombreCriterio)=>{

    switch(nuevoCriterio){
        case 'tanda' : nombreCriterio.current = 'Seleccione la tanda:';return
        case 'añofiscal' : nombreCriterio.current = 'Seleccione el año fiscal:';return
        case 'mesaño' : nombreCriterio.current = 'Seleccione el mes y año:';return
        case 'periodo' : nombreCriterio.current = 'Seleccione el período:' ;return
        case 'año' : nombreCriterio.current = 'Seleccione el año:';return
        case 'fecha' : nombreCriterio.current = 'Seleccione la fecha:';return
    }
}